/**
 *    __ _ _      _
 *  / _(_) |_   (_)___
 * | |_| | __|  | / __|
 * |  _| | |_ _ | \__ \
 * |_| |_|\__(_)/ |___/
 *            |__/
 * @ScriptName  : fit.js
 * @Version     : 1.1.0
 * @Author      : masahiro.imanaka / naoki.umeyama / mamoru.yoshida / hirofumi.sasaki
 * @Description :
 *
 * [履歴]
 *  ver1.1.0: iOS13対応の処理を追加。font指定をemで行う前提の構成に変更。
 *
 * [解説]
 * fit.jsは、固定幅で作成したコンテンツを、端末画面幅にあわせてzoomすることで画面幅にフィットさせるライブラリです。
 * コンテンツを可変させることを前提としたレスポンシブデザインとは全く違う思想で、レスポンシブデザインを実現します。
 * Chrome・Safariはzoom、FirefoxとIEはcss3のtransformで、画面幅にあわせ拡大します。
 *
 * [使い方]
 * fitさせたいコンテンツを下記のDOM構造で記述します。
 * ------------------------------------------------------------
 * 	通常
 * ------------------------------------------------------------
 * 	<div class="js-fit">
 * 		<div class="js-fit-zoom">
 * 			fitさせたいコンテンツ
 * 		</div>
 * 	</div>
 *
 * ------------------------------------------------------------
 * 	position:fixed の要素
 * ------------------------------------------------------------
 * 	<div class="js-fit" data-is-fixed>
 * 		<div class="js-fit-zoom">
 * 			fitさせたい position: fixed; のコンテンツ
 * 		</div>
 * 	</div>
 *
 * ------------------------------------------------------------
 *
 * その他、注意点として、fit.jsの対象のDOMの範囲内に、
 * 下記の要素がある場合、特別な対応が必要となります。
 *
 *	- position:fixed; の要素
 *	- iframe要素(Twitter,FBのWidet等も含む)
 *	- 画面内のoffset値（アンカー処理等）
 *
 */


(function(){
	Fit = FitContents = window.Fit || {

		// 案件によって、変更しても問題ない場所
		config: {
			// PCとSPではコンテンツをフィットさせる端末幅が変わるため、
			// 端末ごとの横幅の範囲（min〜max）をを指定する
			resizeData: [
				{
					min: 320,
					max: 737,
					contentWidth: 320,
					mode: "sp"
				},
				{
					min: 737,
					max: 1200,
					contentWidth: 1200,
					mode: "pc"
				}
			],

			// 処理対象セレクタの指定
			selector: {
				container: 'js-fit',
				zoom: 'js-fit-zoom',
			},
			attribute: {
				fixed: "data-is-fixed"
			},

			// スマホ時に、リサイズイベントでtext-size-adjustを
			// 自動で良きように設定する処理を入れる
			isAutoTextSizeAdjust: true
		},

		// Chrome・Safari用
		_ZOOM: "zoom",

		// Firefox・IE用
		_TRANSFORM: "transform",

		// SP判定
		// isSP: /iphone|ipad|ipod|android/i.test(navigator.userAgent),
		isSP: (function() {
			if(/iphone|ipad|ipod|android/i.test(navigator.userAgent)) {
				return true;
			} else {
				// iPadOSはデフォルトのUserAgentがmacOSと同じになるため、タッチイベントに対応しているかを判定する
				if(/safari/i.test(navigator.userAgent) && typeof document.ontouchstart !== 'undefined') {
					return true;
				} else {
					return false;
				}
			}
		})(),

		// iOS13のiPadかどうか
		_is_iOS13_iPad: (function() {
			if(navigator.platform == "iPad" ||
				(navigator.platform == "MacIntel" &&
				navigator.userAgent.indexOf("Safari") != -1 &&
				navigator.userAgent.indexOf("Chrome") == -1 &&
				navigator.standalone !== undefined)) {

				var ua = navigator.userAgent;

				// バージョンを取得
				var version = ua.toLowerCase().split('version/')[1].split(' ')[0];
				version = version.split('.')[0];

				// iOS11以上のSafari
				if (version >= 13 && ua.toLowerCase().indexOf('version/') >= 0){
					// console.log('iOS13以上のiPad');
					document.body.className += 'is-ios13-hotfix';
					return true;
				} else {
					return false;
				}

			} else {
				return false;
			}
		})(),

		// 画面横幅
		htmlWidth: 0,
		// 画面高さ
		htmlHeight: 0,
		// 拡大率
		zoomScale: 1,

		// resizeDataで設定したmodeが、現在適応されているデータに応じて反映される
		mode: null,


		// レイアウト変更（modeがpcからspに変更等）のフラグ
		// ※Facebookのウィジェットをパースさせ直すためのフラグとして使える
		isLayoutChange: true,

		// スケール変更時のフラグ
		isScaleChange: true,

		// 現在適応されているresizeDataのインデックス値
		_dataIndex: 0,


		// 最大幅・最小幅を格納するためのオブジェクト
		applyRange: {},


		// ユーザーエジェントにあわせた、
		// 拡大処理に利用するcssのプロパティ
		zoomType: (function() {
			if(/msie|trident|firefox/i.test(navigator.userAgent)) {
				return "transform";
			} else {
				return "zoom";
			}
		})() ,


		// zoom値を格納する<style>タグ
		style: document.createElement("style"),




		/**
		 * fit.jsの起動処理
		 *
		 * @method  constructor
		 */
		constructor: function(){

			var _this = this, i;

			// レスポンシブ処理を反映させる幅の範囲の設定
			this.applyRange = {
				min: this.config.resizeData[0].min,
				max: this.config.resizeData[0].max
			};
			for( var i = 1; i < this.config.resizeData.length; i++ ) {
				if( this.applyRange.min > this.config.resizeData[i].min ){
					this.applyRange.min = this.config.resizeData[i].min;
				}
				if( this.applyRange.max < this.config.resizeData[i].max ){
					this.applyRange.max = this.config.resizeData[i].max;
				}
			};

			document.head.appendChild( this.style ) ;

			// リサイズイベント処理
			_this.onResize = function(evt){
				_this.calcZoomScale();
				_this.onBeforeFit();
				_this.fit() ;
				_this.onAfterFit();
			}


			_this.onBeforeFit = function( ){
				for(i = 0; i < _this.onBeforeFit.task.length; i++){
					this.onBeforeFit.task[i]();
				}
			}
			_this.onBeforeFit.task = [];
			_this.onBeforeFit.add = function(func){
				_this.onBeforeFit.task.push(func);
			}


			_this.onAfterFit = function( ){
				for(i = 0; i < _this.onAfterFit.task.length; i++){
					this.onAfterFit.task[i]();
				}
			}
			_this.onAfterFit.task = [];
			_this.onAfterFit.add = function(func){
				_this.onAfterFit.task.push(func);
			}


			// 初回他の一度だけ計算をしておく
			_this.calcZoomScale( );
			window.requestAnimationFrame( function() {
				_this.onResize();
				window.addEventListener("resize", _this.onResize) ;

				// アンカー遷移先がズレる問題の解消
				if( location.hash != "" ){
					var target = document.getElementById( location.hash.replace( /#/ , "" ) ) ;
					if( target ){
						window.requestAnimationFrame( function( ){
							var top = Fit.getOffsetTop( target ) ;
							top = top * Fit.zoomScale ;

							window.scrollTo( 0 , top ) ;
						} ) ;
					}
				}
			} );
		},


		/**
		 * zoom値を割り出す計算
		 */
		calcZoomScale: function(){

			var prevIndex = this._dataIndex ;
			var settingScale ;

			this.htmlWidth = document.documentElement.offsetWidth;
			this.htmlHeight = document.documentElement.offsetHeight;

			this._dataIndex = 0 ;


			// ズーム値を決定
			if( this.htmlWidth < this.applyRange.min ) {
				// レスポンシブ範囲以下のフィットは計算で出す
				this._dataIndex = 0 ;
				this.data = this.config.resizeData[ this._dataIndex ] ;
				settingScale = this.applyRange.min / this.data.contentWidth ;
				this.mode = this.data.mode ;
			}else if( this.htmlWidth >= this.applyRange.max ) {
				// レスポンシブ範囲以上はフィット値をリセット
				this._dataIndex = this.config.resizeData.length-1 ;
				this.data = null ;
				settingScale = 1 ;
				this.mode = null ;
			}else {
				// レスポンシブ範囲内のフィットは計算で出す
				for( i = 0 ; i < this.config.resizeData.length ; i++ )
				{
					var temp = this.config.resizeData[i] ;
					if( temp.min <= this.htmlWidth && this.htmlWidth < temp.max ){
						break ;
					}
				}

				this._dataIndex = i ;
				this.data = this.config.resizeData[ this._dataIndex ] ;
				settingScale = this.htmlWidth / this.data.contentWidth ;
				if( this.data.maxScale && this.data.maxScale < settingScale ){
					settingScale = this.data.maxScale;
				}
				this.mode = this.data.mode ;
			}


			// 各挙動フラグを取得
			this.isLayoutChange = prevIndex != this._dataIndex ;
			this.isScaleChange = this.zoomScale != settingScale ;
			this.zoomScale = settingScale ;
		},


		/**
		 * zoom値をスタイルに適応させる処理
		 */
		fit: function(){

			var zoomStyle = "";
			var containerStyle = "";
			var fixedZoomStyle = "";
			switch (this.zoomType) {
				case this._ZOOM :
					zoomStyle = "zoom: " + Fit.zoomScale + ";";
					fixedZoomStyle = 'height: 100%;';
					// ipadでios13以上のときはfont-sizeも調整する
					if(this._is_iOS13_iPad) {
						zoomStyle += 'font-size: ' + Fit.zoomScale + "em;";
					}
					break;

				case this._TRANSFORM:
					zoomStyle = "width: " + ( this.data ? this.data.contentWidth + "px;" : "auto;" ) +
						"transform: " + "scale(" + Fit.zoomScale + ");";

					// transformでFitさせる場合は、リサイズ時に発生する余分なエリアをトリミングする必要があり、
					// fitさせるコンテンツごとにリサイズ後の高さが違うため、それぞれ計算して、直接DOMにスタイルを当てています
					var container = document.getElementsByClassName(this.config.selector.container);
					for( var i = 0 ; i < container.length ; i++){
						var tempZoom = container[i].getElementsByClassName(this.config.selector.zoom)[0];

						if( container[i].hasAttribute("data-is-fixed") ){
							container[i].style.height = this.htmlHeight + "px";
							tempZoom.style.height = this.htmlHeight / Fit.zoomScale + "px";
						} else{
							container[i].style.height = ( tempZoom.offsetHeight * Fit.zoomScale ) + "px" ;
							tempZoom.style.height = "";
						}
					}

					break;
			}


			var extra = "";
			// スマホ時に、text-size-adjustの影響で、フォントサイズが拡大されることを防ぐ処理
			if( this.config.isAutoTextSizeAdjust && this.isSP ){
				extra = "body{text-size-adjust: " + ( this.htmlWidth < this.htmlHeight ? "100%" : "auto" ) + "};";
			}


			// スタイルの文字列形成
			var styleStr = '.' + Fit.config.selector.container + "{" +
				'opacity: 1;'+
				'top: 0;'+
				'left: 0;'+
				'width: 100%;'+
				'position: relative;'+
				containerStyle +
				( this.zoomType == this._TRANSFORM ? 'overflow: hidden;' : '' ) +
				'min-width: ' + Fit.applyRange.min + 'px;' +
				"}" +

				'.' + Fit.config.selector.zoom + "{" +
				zoomStyle +
				'overflow: hidden;'+
				'transform-origin: 0 0;'+
				"}" +

				'.' + Fit.config.selector.container + "[" + Fit.config.attribute.fixed + "]{" +
				'position: fixed;'+
				'height: 100%;'+
				'pointer-events: none;'+
				"}" +

				'.' + Fit.config.selector.container + "[" + Fit.config.attribute.fixed + "] ." + Fit.config.selector.zoom + "{" +
				fixedZoomStyle +
				"}" +

				'.' + Fit.config.selector.container + "[" + Fit.config.attribute.fixed + "] ." + Fit.config.selector.zoom + " > *{" +
				'pointer-events: auto;'+
				"}" +

				extra ;

			this.style.innerHTML = styleStr ;
		},



		/**
		 * @param target 左上からの位置を取得したい対象のエレメント
		 *        rootTarget 左上を0,0とする対象の親エレメント、デフォルトは<body>タグ
		 */
		getOffsetTop:function( target , rootTarget )
		{
			rootTarget = rootTarget == undefined ? document.body : rootTarget ;
			var top = target.offsetTop ;

			var parent = target.offsetParent ;
			while( parent && parent != rootTarget ){

				top += parent.offsetTop ;
				parent = parent.offsetParent ;
			}

			return top ;
		}
	};


	// requestAnimationFrameを多くのブラウザで利用するための、prefix指定
	window.requestAnimationFrame =	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	// Configパラメータの上書き
	if (app && app.init && app.init.fit) {
		if(app.init.fit.resizeData) {
			Fit.config.resizeData = app.init.fit.resizeData;
		}
		if(app.init.fit.selector) {
			Fit.config.selector = app.init.fit.selector;
		}
		if(app.init.fit.attribute) {
			Fit.config.attribute = app.init.fit.attribute;
		}
		if(app.init.fit.isAutoTextSizeAdjust !== undefined) {
			Fit.config.isAutoTextSizeAdjust = app.init.fit.isAutoTextSizeAdjust;
		}
	}


	// DOMの準備が完了したら、Fit.initializeを呼ぶ
	if( app && app.init && app.init.fit && app.init.fit.readyFlag ){
		document.readyState === "complete"
			? setTimeout( function(){ Fit.constructor(); } , 1 )
			: document.addEventListener( "DOMContentLoaded", function(){ Fit.constructor(); } ) ;
	}else{
		Fit.constructor();
	}

})();
